class SlowDowner {
    constructor() {
        this.playing = false;
        this.time = null;
        this.friction = null;
        this.power = null;
        this.updateCb = null;
        this.animate = this.animate.bind(this);
    }

    start(time, power, friction) {
        this.playing = true;
        this.power = Math.abs(power);
        this.sign = power > 0 ? -1 : 1;
        this.friction = friction;
        this.time = time;
        if (this.onStart) this.onStart();
        this.animate();
    }

    reset() {
        this.playing = false;
        this.time = null;
        this.friction = null;
        this.power = null;
        this.updateCb = null;
    }

    stop() {
        this.playing = false;
        if (this.updateCb) this.updateCb();
    }

    animate() {
        if (!this.playing) return;

        if (this.power > 0) {
            this.time = this.time - (this.sign * this.power);
            this.power = this.power - this.friction;
            if (this.onUpdate) this.onUpdate();
        } else {
            this.playing = false;
            if (this.onEnd) this.onEnd()
        }

        requestAnimationFrame(this.animate)
    }

    onStart() {}

    onEnd() {}

    onUpdate() {}
}

export default new SlowDowner()